<header>
  <app-back-to-system-overview
    relativeUrl="../../"
  ></app-back-to-system-overview>
  <sh-text id="startup-pane-header-last-update" color="secondary">
    {{ 'cts.gantry.lastUpdate' | translate }}
    {{ updatedDate | timeFromNow: 'unknown' }}
  </sh-text>
</header>

<sh-card>
  <div class="tabs-timezone">
    <sh-tabs role="tablist" slot="header">
      <sh-tab-item
        label="{{ 'cts.gantry.init' | translate }}"
        [active]="activeTab === TAB_GANTRY_INIT"
        (click)="updateActiveTab(TAB_GANTRY_INIT)"
        (keydown.enter)="updateActiveTab(TAB_GANTRY_INIT)"
      ></sh-tab-item>
    </sh-tabs>
    <app-cts-gantry-timezone-select
      [localDeviceOffset]="updatedDateOffset"
    ></app-cts-gantry-timezone-select>
  </div>

  @switch (activeTab) {
    @case (TAB_GANTRY_INIT) {
      <api-call-gate [apiCall]="gantryEvents">
        <ng-template #lastSuccessfulData let-data>
          <app-cts-gantry-init
            [systemDetails]="systemDetails$ | async"
            [events]="data?.events ?? []"
            [logCacheModel]="logCacheModel"
            [selectionModel]="selectionModel"
            [selectedEvent]="selectedEvent"
            (selectedEventChange)="selectedEvent = $event"
          ></app-cts-gantry-init>
        </ng-template>
      </api-call-gate>
    }
  }
</sh-card>
